import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/register.css";
import { db } from "../firebaseConfig";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";

const vehicleOptions = ["Motorcycle", "Tricycle", "Car", "Bus", "Truck", "Others"];

const Register = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    phone: "",
    altPhone: "",
    email: "",
    address: "",
    customerType: "",
    customerTypeOther: "",
    plan: "Basic",
    billingFrequency: "3 Months",
    vehicles: [
      { type: "", customType: "", regNumber: "", manufacturer: "", modelYear: "", color: "" }
    ],
    installDate: "",
    installTime: "",
    installLocation: "",
    agreedToTerms: false,
  });

  const [loading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const handleVehicleChange = (index, field, value) => {
    const updatedVehicles = [...form.vehicles];
    updatedVehicles[index][field] = value;
    setForm({ ...form, vehicles: updatedVehicles });
  };

  const addVehicle = () => {
    setForm({
      ...form,
      vehicles: [
        ...form.vehicles,
        { type: "", customType: "", regNumber: "", manufacturer: "", modelYear: "", color: "" }
      ],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!form.agreedToTerms) {
      alert("❌ Please agree to the terms and conditions.");
      return;
    }
  
    for (let [i, v] of form.vehicles.entries()) {
      if (!v.type || !v.regNumber || !v.color) {
        alert(`❌ Vehicle #${i + 1} is incomplete.`);
        return;
      }
    }
  
    try {
      const docRef = await addDoc(collection(db, "registrations"), {
        ...form,
        status: "pending",
        createdAt: serverTimestamp(),
      });
      if (window.gtag) {
        window.gtag('event', 'registration_complete', {
          method: 'email',
        });
      }
  
      // Redirect with Firestore ID and form for payment
      navigate("/payment", {
        state: { form, regId: docRef.id },
      });
    } catch (error) {
      console.error("🔥 Firestore error:", error);
      alert("❌ Failed to submit registration. Try again.");
    }
  };

  return (
    <div className="register-container">
      <form className="register-form" onSubmit={handleSubmit}>
        <h2>Customer Registration</h2>

        {/* SECTION 1: Personal Info */}
        <h4>Section 1: Personal Details</h4>
        <input name="name" placeholder="Business or Individual Name" onChange={handleInputChange} required />
        <input name="phone" placeholder="Phone Number" onChange={handleInputChange} required />
        <input name="altPhone" placeholder="Alternative Phone Number" onChange={handleInputChange} />
        <input name="email" type="email" placeholder="Email Address" onChange={handleInputChange} required />
        <input name="address" placeholder="Address (Street, City, State)" onChange={handleInputChange} required />
        <label>Customer Type</label>
        <select name="customerType" onChange={handleInputChange}>
          <option>Personal Vehicle</option>
          <option>Logistics/Delivery</option>
          <option>Public Transport</option>
          <option>Company's Fleet</option>
          <option>Others</option>
        </select>
        {form.customerType === "Others" && (
          <input name="customerTypeOther" placeholder="Please specify" onChange={handleInputChange} />
        )}

        {/* SECTION 2: Subscription */}
        <h4>Section 2: Subscription Plan</h4>
        <select name="plan" onChange={handleInputChange}>
          <option>Basic</option>
          <option>Standard</option>
          <option>Premium</option>
        </select>
        <label>How many months?</label>
        <select name="billingFrequency" onChange={handleInputChange}>
          <option>3 Months</option>
          <option>6 Months</option>
          <option>12 Months</option>
        </select>

        {/* SECTION 3: Vehicle Info */}
        <h4>Section 3: Vehicle Information</h4>
        {form.vehicles.map((vehicle, idx) => (
          <div key={idx} className="vehicle-block">
            <select value={vehicle.type} onChange={(e) => handleVehicleChange(idx, "type", e.target.value)}>
              <option value="">Select Vehicle Type</option>
              {vehicleOptions.map((opt) => (
                <option key={opt}>{opt}</option>
              ))}
            </select>
            {vehicle.type === "Others" && (
              <input placeholder="Specify Type" value={vehicle.customType} onChange={(e) => handleVehicleChange(idx, "customType", e.target.value)} />
            )}
            <input placeholder="Registration Number" value={vehicle.regNumber} onChange={(e) => handleVehicleChange(idx, "regNumber", e.target.value)} />
            <input placeholder="Manufacturer" value={vehicle.manufacturer} onChange={(e) => handleVehicleChange(idx, "manufacturer", e.target.value)} />
            <input placeholder="Model/Year" value={vehicle.modelYear} onChange={(e) => handleVehicleChange(idx, "modelYear", e.target.value)} />
            <input placeholder="Color" value={vehicle.color} onChange={(e) => handleVehicleChange(idx, "color", e.target.value)} />
          </div>
        ))}
        <button type="button" className="add-vehicle-btn" onClick={addVehicle}>➕ Add Vehicle</button>

        {/* SECTION 4: Installation */}
        <h4>Section 4: Tracking Device Installation Schedule</h4>
        <input name="installDate" type="date" onChange={handleInputChange} required />
                <input name="installLocation" placeholder="Preferred Location" onChange={handleInputChange} required />
        <label className="terms">
          <input type="checkbox" name="agreedToTerms" checked={form.agreedToTerms} onChange={handleInputChange} />
          I agree to the <a href="/terms" target="_blank">Terms & Conditions</a>
        </label>

        <button type="submit" disabled={loading}>
          {loading ? "Redirecting..." : "Submit & Continue to Payment"}
        </button>
      </form>
    </div>
  );
};

export default Register;
